module.exports = __webpack_public_path__ + "img/p32.7379d35a.svg";